import React, { useState } from 'react';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Sidebar = () => {
  const [open, setOpen] = useState(false);

  const handleToggle = () => setOpen(!open);
  const handleLinkClick = () => setOpen(false);

  return (
    <>
      {/* Hamburger icon for mobile */}
   
      <div className={`sidebar desktop-sidebar bg-dark text-white vh-100${open ? ' open' : ''}`}>
        <Nav className="flex-column p-3">
          <Nav.Link as={Link} to="/dashboard" className="text-white" onClick={handleLinkClick}>
            <span className="sidebar-icon">🏠</span> Dashboard
          </Nav.Link>
          <Nav.Link as={Link} to="/dashboard/overview" className="text-white" onClick={handleLinkClick}>
            <span className="sidebar-icon">📋</span> Overview
          </Nav.Link>
          <Nav.Link as={Link} to="/dashboard/my-businesses" className="text-white" onClick={handleLinkClick}>
            <span className="sidebar-icon">📋</span> My Businesses
          </Nav.Link>
          <Nav.Link as={Link} to="/add-business" className="text-white" onClick={handleLinkClick}>
            <span className="sidebar-icon">➕</span> Add Business
          </Nav.Link>
          <Nav.Link as={Link} to="/dashboard/reviews" className="text-white" onClick={handleLinkClick}>
            <span className="sidebar-icon">⭐</span> Reviews
          </Nav.Link>
          <Nav.Link as={Link} to="/dashboard/messages" className="text-white" onClick={handleLinkClick}>
            <span className="sidebar-icon">✉️</span> Messages
          </Nav.Link>
          <Nav.Link as={Link} to="/dashboard/gallery" className="text-white" onClick={handleLinkClick}>
            <span className="sidebar-icon">🖼️</span> Gallery
          </Nav.Link>
          <Nav.Link as={Link} to="/dashboard/favorites" className="text-white" onClick={handleLinkClick}>
            <span className="sidebar-icon">❤️</span> Favorites
          </Nav.Link>
          <Nav.Link as={Link} to="/dashboard/analytics" className="text-white" onClick={handleLinkClick}>
            <span className="sidebar-icon">📊</span> Analytics
          </Nav.Link>
          <Nav.Link as={Link} to="/dashboard/profile-settings" className="text-white" onClick={handleLinkClick}>
            <span className="sidebar-icon">👤</span> Profile Settings
          </Nav.Link>
          <Nav.Link as={Link} to="/dashboard/billing" className="text-white" onClick={handleLinkClick}>
            <span className="sidebar-icon">💳</span> Billing
          </Nav.Link>
          <Nav.Link as={Link} to="/dashboard/support" className="text-white" onClick={handleLinkClick}>
            <span className="sidebar-icon">❓</span> Support
          </Nav.Link>
          <Nav.Link as={Link} to="/login" className="text-white" onClick={handleLinkClick}>
            <span className="sidebar-icon">🚪</span> Logout
          </Nav.Link>
        </Nav>
      </div>
      {/* Overlay for mobile */}
      {open && <div className="sidebar-overlay" onClick={handleToggle}></div>}
    </>
  );
};

export default Sidebar;
